import React, { useState } from 'react'
import { FaChevronDown } from "react-icons/fa";

const RecentSearches = ({getRecentSearch}) => {
    const [showDropdown, setShowDropdown] = useState(false);
 
    const handleClearSearches = () => {
        localStorage.removeItem('recentSearches');
        setShowDropdown(false);
    };

    const handleDropDown = () => {
        setShowDropdown((prev) => !prev)
    }

    const handleSelectRecentSearch = (s) => {
        getRecentSearch(s)
        setShowDropdown(false);
    }

    return (
        <div className='relative mb-3'>
            <button onClick={handleDropDown} className='flex justify-between items-center w-full gap-5 px-3 py-1 font-semibold bg-[#F8FAFB] rounded-md cursor-pointer text-secondaryLight'>
                <div>Recent Searches</div>
                <FaChevronDown />
            </button>

            {showDropdown && (
                <div className="absolute left-0 right-0 z-50 w-full mt-1 overflow-y-auto bg-gray-100 border border-gray-200 rounded-md shadow-md max-h-56">
                    {JSON.parse(localStorage.getItem('recentSearches') || '[]').length > 0 ? (
                        JSON.parse(localStorage.getItem('recentSearches') || '[]').reverse().map((search, index) => (
                            <button key={index} onClick={() => handleSelectRecentSearch(search)} className="w-full px-4 py-2 text-sm text-left cursor-pointer text-secondaryLight hover:bg-gray-200">
                                {search}
                            </button>
                        ))
                    ) : (
                        <div className="px-4 py-2 text-gray-500 ">No recent searches</div>
                    )}
                    <button onClick={handleClearSearches} className="w-full px-4 py-2 text-red-500 border-t hover:shadow-3"   >    Clear Recent Searches   </button>
                </div>
            )}
        </div>
    )
}

export default RecentSearches